import React from "react";
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import ProbelyCredentialsForm from "./ProbelyCredentialsForm";
import ProbelyConfigListing from "./ProbelyConfigListing";

export default function ProbelyPullAndPushView(props){
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={ProbelyCredentialsForm}
            PullConfigListingView={ProbelyConfigListing}
        />
    )
}